// extracted by mini-css-extract-plugin
export default {"root":"MdRkdCNtRUTP2T3ynKtq","placeHolderShimmer":"qXj15vqc0uTT0bBXbYzx"};